import m from 'mithril';
import { HotelResultSet, LocationResultSet, BookingSessionCreateParams, BookingSession, RoomTypeResult, TemporaryRoomTypeSelection, GuestInfo, BookerInfo, HotelDetail, ErrorDTO, 
    BookingLookupOTP, PaymentInitiateParm, PaymentOption, PromotionErrorDTO, PromoVerifyRequest, TentativeBookingResult, AuthResponse, HotelDetailsByAgent, 
    PaymentIntentCreateResponse, PaymentIntentCreateRequest, CheckConfirmation, BookingDetail, PaymentConfirmation, Article,
    HotelPromotionResult, HotelDetailByAgent, Amenity, UserAccountResultSet, OtpResultSet, UserAccountRequest, UserAccountDetails,
    SearchCriteriaAndHotelResultSet} from './Models';
import HotelSearchCriteria from './states/HotelSearchCriteria';
import BookingSearchCriteria from './states/BookingSearchCriteria';
import HotelLookupCriteria from './states/HotelLookupCriteria';
//import { UUID } from 'crypto';

export class ApiResult<T> {
    private body: T|null;
    private error: ErrorDTO|null|PromotionErrorDTO|string;

    constructor(body:T|null, error:ErrorDTO|null|PromotionErrorDTO|string) {
        this.body = body;
        this.error = error;
    }

    isSuccess() : boolean {
        return this.body != null;
    }

    getBody(): T {
        return this.body as T;
    }

    getError(): ErrorDTO | PromotionErrorDTO | string {
        return this.error as ErrorDTO | PromotionErrorDTO | string;
    }
  }

export class ApiClient {
    apiBaseUrl:string;
    walletUserId:string|null;
    headers = {
        "Content-Type":"application/json",
        "authorization": ""
    }
    
    constructor(apiBaseUrl:string) {
        this.apiBaseUrl = apiBaseUrl;
        this.walletUserId = null;
    }

    setWalletUserId(walletUserId:string|null){
        this.walletUserId = walletUserId;
    }

    getWalletUserId():string|null{
        return this.walletUserId;
    }

    setAuthorization(authorization: string){
        this.headers.authorization = authorization;
    }

    async authentication(agentId:number, channel:string, appUserToken:string):Promise<AuthResponse>{
        let apiUrl = this.apiBaseUrl + "/authentication";
        let jsonBody = {
            "agentId": agentId,
            "channel": channel,
            "appUserToken": appUserToken
        };
        const jsonResponse:AuthResponse = await m.request({
            method: "POST",
            url: apiUrl,
            body: jsonBody
        });

        return jsonResponse;
    }

    async createUserAccountWithPhoneNumber(userAccountRequest: UserAccountRequest): Promise<ApiResult<UserAccountResultSet>> {
        let apiEndpointUrl = this.apiBaseUrl + "/account";

        let jsonBody = {
            "cellPhoneNumber": userAccountRequest.cellPhoneNumber,
            "otpId": userAccountRequest.otpId,
            "otp": userAccountRequest.otp
        };

        console.log("Sending create user account with phone number request body", jsonBody);

        return await m.request({
            method: "POST",
            headers: this.headers,
            url: apiEndpointUrl,
            body: jsonBody,
            extract: function(xhr) {return {status: xhr.status, body: xhr.responseText}}
        }).then((response) => {
            console.log(response.body);
            console.log(response.status);
            if(response.status < 300) {
                let userAccountResultSet = JSON.parse(response.body) as UserAccountResultSet
                console.log(userAccountResultSet);
                return new ApiResult<UserAccountResultSet>(userAccountResultSet, null);
            } else {
                let error = JSON.parse(response.body) as string;
                return new ApiResult<UserAccountResultSet>(null, error);
            }
        });
    }

    getOtp(phoneNumber: string) : Promise<ApiResult<OtpResultSet>> {
        let apiUrl = this.apiBaseUrl + "/otp?phoneNumber=" + phoneNumber;

        return m.request({
            method: "GET",
            url: apiUrl,
            headers: this.headers,
            extract: function(xhr) {return {status: xhr.status, body: xhr.responseText}}
        }).then (response => {
            if(response.status < 300) {
                let otpResultSet = JSON.parse(response.body) as OtpResultSet;
                console.log(otpResultSet);
                return new ApiResult<OtpResultSet>(otpResultSet, null);
            } else {
                let error = JSON.parse(response.body) as string;
                return new ApiResult<OtpResultSet>(null, error);
            }
        })
    }

    getUserAccountByWalletUserId(walletUserId:string) : Promise<UserAccountResultSet> {
        let apiUrl = this.apiBaseUrl + "/account?walletUserId=" + walletUserId;
        return m.request({
            method: "GET",
            url: apiUrl,
            headers: this.headers
        }).then((res:any) => {
            return res as UserAccountResultSet
        });
    }

    getUserAccountDetails(userId: string): Promise<ApiResult<UserAccountDetails>> {
        let apiUrl = this.apiBaseUrl + "/accounts/" + userId;
        return m.request({
            method: "GET",
            url: apiUrl,
            headers: this.headers,
            extract: function(xhr) {return {status: xhr.status, body: xhr.responseText}}
        }).then(response => {
            if(response.status < 300) {
                let userAccountDetails = JSON.parse(response.body) as UserAccountDetails
                console.log(userAccountDetails);
                return new ApiResult<UserAccountDetails>(userAccountDetails, null);
            } else {
                let error = JSON.parse(response.body) as string;
                return new ApiResult<UserAccountDetails>(null, error);
            }
        })
    }

    async getLocations() : Promise<ApiResult<LocationResultSet>> {
        let apiUrl = this.apiBaseUrl + "/locations";
        //console.log("Fetching data form", apiUrl);
        return m.request({
            method: "GET",
            url: apiUrl,
            headers: this.headers,
            extract: function(xhr) {return {status: xhr.status, body: xhr.responseText}}
        }).then( (response) => {
            //console.log("Got data response", response);
            if(response.status < 300) {
                let locationResultSet = JSON.parse(response.body) as LocationResultSet;
                console.log(locationResultSet)
                return new ApiResult<LocationResultSet>(locationResultSet, null);
            } else {
                let error = JSON.parse(response.body) as ErrorDTO;
                return new ApiResult<LocationResultSet>(null, error);
            } 
        })
    }  

    getHotelAmenities(): Promise<Amenity[]> {
        let apiUrl = this.apiBaseUrl + "/hotelAmenities";
        return m.request({
            method: "GET",
            url: apiUrl,
            headers: this.headers
        }).then((jsonResponse:any) => {
            return jsonResponse as Amenity[];
        })
    }

    getHotelsLookup(searchCriteria:HotelLookupCriteria): Promise<HotelResultSet> {
        let apiEndpointUrl = this.apiBaseUrl + "/hotelsLoopup" + 
            "?locationId="+ searchCriteria.getLocation().id +
            "&locationType=" + searchCriteria.getLocation().type;

        if(searchCriteria.getAmenities() != ""){
            apiEndpointUrl = apiEndpointUrl + "&facilities=" + searchCriteria.getAmenities();
        }

        if(searchCriteria.getFilterByTownship()) {
            apiEndpointUrl = apiEndpointUrl + "&filter_by_township=" + searchCriteria.getFilterByTownship();
        }        
        
        if(searchCriteria.getFilterByPriceRange()) {
            apiEndpointUrl = apiEndpointUrl + "&filter_by_price_range=" + searchCriteria.getFilterByPriceRange();
        } 
        
        if(searchCriteria.getSortByPrice()) {
            apiEndpointUrl = apiEndpointUrl + "&sort_by_price=" + searchCriteria.getSortByPrice();
        }    

        return m.request({
            method:"GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then((jsonResponse: any) => {
            console.log(jsonResponse);
            return jsonResponse as HotelResultSet
        })
    }
    
    searchHotels(searchCriteria: HotelSearchCriteria) : Promise<HotelResultSet> {
        let apiEndpointUrl = this.apiBaseUrl + "/searchHotels" + 
            "?locationId=" + searchCriteria.getLocation().id + 
            "&locationType=" + searchCriteria.getLocation().type +
            "&checkInDate=" + searchCriteria.getCheckInDate() +
            "&checkOutDate=" + searchCriteria.getCheckOutDate() + 
            "&guestType=" + searchCriteria.getGuestType() + 
            "&numberOfRooms=" + searchCriteria.getNumberOfRooms() + 
            "&numberOfGuests=1" + 
            "&currency=MMK";

        if(searchCriteria.getFilterByTownship()) {
            apiEndpointUrl = apiEndpointUrl + "&filter_by_township=" + searchCriteria.getFilterByTownship();
        }        
        
        if(searchCriteria.getFilterByPriceRange()) {
            apiEndpointUrl = apiEndpointUrl + "&filter_by_price_range=" + searchCriteria.getFilterByPriceRange();
        } 
        
        if(searchCriteria.getSortByPrice()) {
            apiEndpointUrl = apiEndpointUrl + "&sort_by_price=" + searchCriteria.getSortByPrice();
        }
        
        apiEndpointUrl = apiEndpointUrl + "&offset=" + searchCriteria.getOffset() + "&limit=" + searchCriteria.getSize();
        
        console.log("Searching hotels data from ", apiEndpointUrl , "...");
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl,
        }).then( (jsonResponse:any) => {
            console.log("Got hotel search result ", jsonResponse);
            return jsonResponse as HotelResultSet;
        });
    }

    async createBookingSession(channel:string, params:BookingSessionCreateParams): Promise<BookingSession> {
        let apiEndpointUrl = this.apiBaseUrl + "/createBookingSession";
        //return this.apiClient.createBookingSession(params);
        let jsonBody = {
            "hotelId": params.hotelId,
            "checkInDate": params.checkInDate,
            "checkOutDate": params.checkOutDate,
            "numberOfRooms": params.numberOfRooms,
            "numberOfGuests": 1,
            "guestType": params.guestType,
            "channel": channel
        };

        console.log("Sending booking session create request body", jsonBody);

        const jsonResponse = await m.request({
            method: "POST",
            headers: this.headers,
            url: apiEndpointUrl,
            body: jsonBody
        });
        return jsonResponse as BookingSession;
    }

    async updateBookingSession(bookingSessionId:string, roomTypeSelections:TemporaryRoomTypeSelection[], removedRoomsIds?:string[]): Promise<BookingSession> {
        let apiEndpointUrl = this.apiBaseUrl + "/updateBookingSession/" + bookingSessionId;
        let addedRoomSelections = roomTypeSelections.map(roomTypeSelection => {
            return {
                "bookableOptionId": roomTypeSelection.bookableOption.id,
                "numberOfAdults": roomTypeSelection.numberOfAdults,
                "numberOfChildren": 0,
                "numberOfExtraBeds": roomTypeSelection.numberOfExtraBeds
            }
        });
        let removedRoomSelections = removedRoomsIds?.map( id => {
            return {"id": id}
        });
        
        let jsonBody = {
            "addedRoomSelections": addedRoomSelections,
            "removedRoomSelections": removedRoomsIds? removedRoomSelections : []
        };

        const jsonResponse = await m.request({
            method: "POST",
            headers: this.headers,
            url: apiEndpointUrl,
            body: jsonBody
        });

        return jsonResponse as BookingSession;
    }

    getBookingSession(bookingSessionId: string) : Promise<BookingSession>{
        let apiEndpointUrl = this.apiBaseUrl + "/bookingSessions/" + bookingSessionId;
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then((jsonResponse: any) => {
            return jsonResponse;
        }) 
    }

    getHotelDetails(hotelId: number, checkInDate?: string, checkOutDate?: string) : Promise<HotelDetail>{
        let apiEndpointUrl = (checkInDate && checkInDate)? 
            this.apiBaseUrl + "/hotels/" + hotelId + "?checkInDate=" + checkInDate + "&checkOutDate=" + checkOutDate : 
            this.apiBaseUrl + "/hotels/" + hotelId;
        console.log("Getting hotel details", apiEndpointUrl);
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then((jsonResponse: any) => {
            return jsonResponse;
        }) 
    }

    getRoomTypeResults(bookingSessionId:string) : Promise<RoomTypeResult[]> {
        let apiEndpointUrl = this.apiBaseUrl + "/getRoomTypeAvailability/" + bookingSessionId;
        console.log("Searching room results from ", apiEndpointUrl);
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl,
        }).then((jsonResponse:any) => {
            return jsonResponse;
        });
    }

    async createTentativeBooking(
        channel: string|null,
        bookingSessionId:string, guest:GuestInfo, booker:BookerInfo, 
        totalAdults: number, totalChildren: number,
        specialRequest:string): Promise<ApiResult<TentativeBookingResult>> {
        
        let apiEndpointUrl = this.apiBaseUrl + "/createTentativeBooking";        
        let jsonBody = {
            "channel": channel,
            "bookingSessionId": bookingSessionId,
            "booker": booker,
            "guest": guest,
            "specialRequest": specialRequest,
            "numberOfAdults": totalAdults,
            "numberOfChildren": totalChildren
        };

        console.log("api client: creating tentative booking ", apiEndpointUrl, jsonBody);
        const response = await m.request({
            method: "POST",
            headers: this.headers,
            url: apiEndpointUrl,
            body: jsonBody,
            extract: function(xhr) {return {status: xhr.status, body: xhr.responseText}}
        });

        if(response.status < 300) {
            let result = JSON.parse(response.body) as TentativeBookingResult;
            console.log("api client create tentative booking");
            console.log(result)
            return new ApiResult<TentativeBookingResult>(result, null);
        } else {
            let error = JSON.parse(response.body) as ErrorDTO;
            return new ApiResult<TentativeBookingResult>(null, error);
        }
    }

    async payTentativeBookingNow(tentativeBookingId:string, channel:string): Promise<ApiResult<PaymentInitiateParm>>{
        let apiEndpointUrl = this.apiBaseUrl + "/paynow";
        let jsonBody = {
            "channel": channel,
            "tentativeBookingId": tentativeBookingId
        }
        console.log("api client: pay tentative booking now ", apiEndpointUrl, jsonBody);

        const response = await m.request({
            method: "POST",
            headers: this.headers,
            url: apiEndpointUrl,
            body: jsonBody,
            extract: function(xhr) {return {status: xhr.status, body: xhr.responseText}}
        });

        if(response.status < 300){
            let paymentInitiateParm = JSON.parse(response.body) as PaymentInitiateParm;
            return new ApiResult<PaymentInitiateParm>(paymentInitiateParm, null);
        }else{
            let error = JSON.parse(response.body) as ErrorDTO;
            return new ApiResult<PaymentInitiateParm>(null, error);
        }
    }

    async sentBookingLookupOtp(townId:number, checkInDate:string, checkOutDate:string, email:string|null, phoneNumber:string|null)
        : Promise<ApiResult<BookingLookupOTP>> {
        let apiEndpointUrl = this.apiBaseUrl + "/bookingLookup/sentOtp";
        console.log("api end point url : " + this.apiBaseUrl);
        
        let jsonBody = {
            "townId": townId,
            "checkInDate": checkInDate,
            "checkOutDate": checkOutDate,
            "email": email,
            "phoneNumber": phoneNumber
        };

        console.log("json body : " + jsonBody);

        const response = await m.request({
            method: "POST",
            headers: this.headers,
            url: apiEndpointUrl,
            body: jsonBody,
            extract: function(xhr) {return {status: xhr.status, body: xhr.responseText}}
        });

        console.log(response.status)

        if(response.status < 300) {
            let bookingLookupOTP = JSON.parse(response.body) as BookingLookupOTP;
            return new ApiResult<BookingLookupOTP>(bookingLookupOTP, null);
        } else {
            let error = JSON.parse(response.body) as ErrorDTO;
            return new ApiResult<BookingLookupOTP>(null, error);
        }
    }

    getBookingLookup(searchCriteria: BookingSearchCriteria|null, walletUserId: string|null) : Promise<BookingDetail[]> {
        let apiEndpointUrl = this.apiBaseUrl + "/bookingLookup";

        if(searchCriteria != null){
            apiEndpointUrl = apiEndpointUrl + "?townId=" + searchCriteria.getLocation().id + 
            "&checkInDate=" + searchCriteria.getCheckInDate() +
            "&checkOutDate=" + searchCriteria.getCheckOutDate();

            if(searchCriteria.getEmail() != null){
                apiEndpointUrl = apiEndpointUrl + "&email=" + searchCriteria.getEmail();
            }
    
            if(searchCriteria.getPhoneNumber() != null){
                apiEndpointUrl = apiEndpointUrl + "&phoneNumber=" + searchCriteria.getPhoneNumber();
            }  

            if(walletUserId != null){
                apiEndpointUrl = apiEndpointUrl + "&walletUserId=" + searchCriteria.getPhoneNumber();
            }
        }
        
        if(walletUserId != null){
            apiEndpointUrl = apiEndpointUrl + "?walletUserId=" + walletUserId;
        }

        console.log("url : " + apiEndpointUrl);
        
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl,
        }).then( (response: any) => {
            console.log(response)
            return response;
        });
    }

    getPaymentOptions(hotelId: number, tenativeBookingId: string) : Promise<PaymentOption[]> {
        let apiEndpointUrl = this.apiBaseUrl + "/tentativeBookings/" + tenativeBookingId + "/options/json?hotelId="+hotelId;
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then( (response: any) => {
            console.log(response)
            return response;
        });     
    }

    async verifyPromotion(channel:string, hotelId:number, tenativeBookingId: string, option: PaymentOption, promoCode: string): Promise<ApiResult<PaymentOption[]>>{
        let apiEndpointUrl = this.apiBaseUrl +  "/tentativeBookings/" + tenativeBookingId + "/promotion/verify";
        console.log("api end point url : " + apiEndpointUrl);

        let jsonBody:PromoVerifyRequest = {
            "channel": channel,
            "hotelId": hotelId,
            "paymentMethodCode": option.paymentMethod.code,
            "tentativeBookingId": tenativeBookingId,
            "promoCode": promoCode,
        };

        console.log(jsonBody)

        const response = await m.request({
            method: "POST",
            headers: this.headers,
            url: apiEndpointUrl,
            body: jsonBody,
            extract: function(xhr) {
                console.log("extract status : " + xhr.status);
                console.log("extract response test : " + xhr.responseText);
                return {
                    status: xhr.status, body: xhr.responseText
                }
            }
        });

        console.log(response.status)

        if(response.status < 300) {
            let paymentOption = JSON.parse(response.body) as PaymentOption[];
            console.log(paymentOption)
            return new ApiResult<PaymentOption[]>(paymentOption, null);
        } else {
            console.log(JSON.parse(response.body))
            let error = JSON.parse(response.body) as PromotionErrorDTO;
            return new ApiResult<PaymentOption[]>(null, error);
        }
    }

    async removePromotion(channel:string, hotelId:number, tenativeBookingId: string, option: PaymentOption): Promise<ApiResult<PaymentOption[]>>{
        let apiEndpointUrl = this.apiBaseUrl +  "/tentativeBookings/" + tenativeBookingId + "/promotion/remove";
        console.log("api end point url : " + apiEndpointUrl);

        let jsonBody = {
            "channel": channel,
            "hotelId": hotelId,
            "paymentMethodCode": option.paymentMethod.code,
            "tentativeBookingId": tenativeBookingId,
            "promoCode": null,
        };

        console.log(jsonBody)

        const response = await m.request({
            method: "POST",
            headers: this.headers,
            url: apiEndpointUrl,
            body: jsonBody,
            extract: function(xhr) {return {status: xhr.status, body: xhr.responseText}}
        });

        console.log(response.status)

        if(response.status < 300) {
            let paymentOption = JSON.parse(response.body) as PaymentOption[];
            console.log(paymentOption)
            return new ApiResult<PaymentOption[]>(paymentOption, null);
        } else {
            let error = JSON.parse(response.body) as PromotionErrorDTO;
            return new ApiResult<PaymentOption[]>(null, error);
        }
    }

    getHotelsByAgent(agentId: number) : Promise<HotelDetailsByAgent>{
        let apiEndpointUrl = this.apiBaseUrl + "/agents/" + agentId + "/hotels";
        console.log("Getting hotel details", apiEndpointUrl);
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then((jsonResponse: any) => {
            console.log(jsonResponse)
            return jsonResponse;
        }) 
    }

    
    getHotelByAgent(agentId: number, hotelId:number) : Promise<HotelDetailByAgent>{
        let apiEndpointUrl = this.apiBaseUrl + "/agents/" + agentId + "/hotels/" + hotelId;
        console.log("Getting hotel detail", apiEndpointUrl);
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then((jsonResponse: any) => {
            console.log(jsonResponse)
            return jsonResponse;
        }) 
    }

    getHotelPromotionResults(): Promise<HotelPromotionResult[]>{
        let apiEndpointUrl = this.apiBaseUrl + "/hotelPromotions";
        console.log("Getting hotel promotions ", apiEndpointUrl);
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then((jsonResponse: any) => {
            console.log(jsonResponse)
            return jsonResponse;
        })
    }

    async createPaymentIntent(paymentToken: string) : Promise<ApiResult<PaymentIntentCreateResponse>> {
        let apiEndpointUrl = this.apiBaseUrl + "/paymentIntent";
        console.log("api end point url : " + apiEndpointUrl);

        let jsonBody:PaymentIntentCreateRequest = {
            paymentToken: paymentToken
        };

        const response = await m.request({
            method: "POST",
            headers: this.headers,
            url: apiEndpointUrl,
            body: jsonBody,
            extract: function(xhr) {return {status: xhr.status, body: xhr.responseText}}
        });

        console.log(response.status)

        if(response.status < 300) {
            let paymentIntentCreateResponse = JSON.parse(response.body) as PaymentIntentCreateResponse;
            console.log(paymentIntentCreateResponse)
            return new ApiResult<PaymentIntentCreateResponse>(paymentIntentCreateResponse, null);
        } else {
            console.log(response.body)
            let error = JSON.parse(response.body) as ErrorDTO;
            return new ApiResult<PaymentIntentCreateResponse>(null, error);
        }
    }

    checkConfirmation(tentativeBookingId:string): Promise<CheckConfirmation>{
        let apiEndpointUrl = this.apiBaseUrl + "/tentativeBookings/" + tentativeBookingId + "/checkConfirmation";
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then((jsonResponse: any) => {
            return jsonResponse;
        }) 
    }

    checkPaymentProcessing(tentativeBookingId:string): Promise<PaymentConfirmation> {
        let apiEndpointUrl = this.apiBaseUrl + "/tentativeBookings/" + tentativeBookingId + "/checkPaymentProcessing";
        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then((jsonResponse: any) => {
            return jsonResponse;
        }) 
    } 

    getArticle(agentId:number, slug:string) : Promise<Article> {
        let apiEndpointUrl = this.apiBaseUrl + "/agents/" + agentId + "/" + slug;
        console.log("Getting article : ", apiEndpointUrl);

        return m.request({
            method: "GET",
            headers: this.headers,
            url: apiEndpointUrl
        }).then((jsonResponse: any) => {
            console.log(jsonResponse)
            return jsonResponse;
        }) 
    }
}